<template>
    <div class="protocol_search_input" :class="{'active' : $props.focusSearchInput}">
        <input type="text"
               @keyup="inputEnter"
               @click="setSearchInput"
               @focus="setFocusSearchInput(true)"
               ref="protocolSearchInput"
               :placeholder="$props.placeholder"
        >
        <button type="button"
                @click="clearData"
        >초기화
        </button>
        <button type="button" class="filter" @click="$emit('update:showFilter',!showFilter)" :class="{'on' : showFilter}">필터</button>
        <div class="protocol_search_box" v-show="pupularDataList.length > 0">
            <ul class="protocol_search_list_area">
                <li v-for="(value, index) in pupularDataList"
                    :key="index"
                    @click="searchPopularData($event, value);">
                    <a href="javascript:void(0);"
                    >{{value}}</a>
                </li>
            </ul>
        </div>
        <div class="protocol_filter_box" :class="{'active' : showFilter}">
            <ul class="protocol_filter_list_area">
                <li v-for="(row,index) in $props.optionList" :key="index">
                    <span class="chk">
                        <input :id="`filterCheck_${index}`" type="checkbox" :value="row.value" @click="callCheckFunction($event, index)" :checked="row.checked">
                        <label :for="`filterCheck_${index}`">{{row.text}}</label>
                    </span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            focusSearchInput        : { type: Boolean, default() { return false; },},
            searchInputData         : { type: String, default() { return ""; },},
            placeholder             : { type: String, default() { return "검색어를 입력하세요"; },},
            selectSearchProcessType : { type: String, default() { return ""; },},
            optionList : { type: Array, default() { return []; },},
            showFilter        : { type: Boolean, default() { return false; },},
        },
        data() {
            return {
                pupularDataList: [],
                searchInputDataTimer: null,
                searchInputDataDelay: 250,
            }
        },
        mounted() {
        },
        watch: {
            "$props.searchInputData"(value) {
                this.$refs.protocolSearchInput.value = this.$props.searchInputData;
                this.$emit("setSearchInputData", this.$props.searchInputData);
                if(value.length == 0){
                    this.pupularDataList = [];
                }
                clearTimeout(this.searchInputDataTimer);
                this.searchInputDataTimer = setTimeout(
                async () => {
                            if(value.length != 0) {
                                this.pupularDataList = await this.$wApi.trace.popularData({
                                    query: value,
                                    lang: "kor",
                                    searchType: this.$props.selectSearchProcessType,
                                });
                            }else{
                                this.pupularDataList = [];
                            }
                        }, this.searchInputDataDelay
                    );
            },
        },
        methods: {
            inputEnter(event) {
                this.$emit('setSearchInputData',event.target.value); 
                this.$emit("inputEnter", event);
            },
            setFocusSearchInput(value) {
                this.$emit("setFocusSearchInput", value);
            },
            async setSearchInput() {
                if( this.searchInputData.length != 0 ) {
                    this.pupularDataList = await this.$wApi.trace.popularData({
                        query: this.$props.searchInputData,
                        lang: "kor",
                        searchType: this.selectSearchProcessType,
                    });                    
                }
            },
            searchPopularData(event, value) {
                this.$emit('setSearchInputData',value); 
                this.$emit("setFocusSearchInput", false);
                const path = "/platform/search" 
                this.$router.push({
                    path : path , 
                    query : {
                        query : value,
                    },
                });
            },
            clearData() {
                this.pupularDataList = []; 
                this.$emit('setSearchInputData',''); 
                this.$refs.protocolSearchInput.value = '';
                this.$refs.protocolSearchInput.focus()
            },
            callCheckFunction(event, index) {
                this.$emit('checkOption', event, index)
            }, 
        }
    }
</script>